<template>
	<div class="site">
		<common-layout>
			<div slot="header">
				<h3>场地管理</h3>
			</div>
			<div slot="container">
				<div class="site.header">
					<el-button type="success" class="site.addBtn" @click="openSiteModal('')">新增场地</el-button>
					<section>
						<el-input placeholder="请输入" v-model="searchValue" class="input-with-select" clearable @change="search">
							<el-button slot="append" icon="el-icon-search"></el-button>
						</el-input>
					</section>
				</div>
				<div class="site.table">
					<el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerStyle">
						<el-table-column type="index" :index="(index) => {return index+ (current_page - 1) * per_page + 1}" label="序号"
						 align="center"></el-table-column>
						<el-table-column prop="fieldName" label="场地名称" align="center"></el-table-column>
						<el-table-column label="场地状态" align="center">
							<template slot-scope="scope">
								<el-tag type="success" v-if="scope.row.isCan == 1">可预约</el-tag>
								<el-tag type="info" v-else>不可预约</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<el-button style="margin-bottom: 5px;" size="mini" @click="openSiteModal(scope.row)">编辑</el-button>
								<el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!-- 分页 -->
					<div class="pagination">
						<div class="grid-content bg-purple-light">
							<el-pagination @current-change="handleCurrentChange" :hide-on-single-page="true" layout="total, prev, pager, next,jumper"
							 :total="total" :current-page.sync="current_page" :page-size="per_page"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</common-layout>

		<!-- 新增场地 -->
		<el-dialog :title=" this.operationType === 'add'  ? '新增场地' : '编辑场地'" :visible.sync="dialogFormVisible"
		 :close-on-click-modal="false" @closed="is_submit = true">
			<el-form :model="form" :rules="siteFormRule" ref="siteFormRule">
				<div class="form-title">基本信息</div>
				<el-form-item label="场地名称:" :label-width="formLabelWidth" class="rowItem" prop="fieldName">
					<el-input v-model="form.fieldName" placeholder="请输入场地名称"></el-input>
				</el-form-item>
				<el-form-item label="是否收费:" :label-width="formLabelWidth" class="rowItem" prop="image">
					<!-- <el-upload class="avatar-uploader" :action="this.uploadURL" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :http-request="HouImgFile">
						<img v-if="form.image" :src="imgUrl + form.image" class="avatar" />
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>-->
					<el-radio-group v-model="form.isFree" size="mini">
						<el-radio :label="1" border>免费</el-radio>
						<el-radio :label="2" border>收费</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="场地面积:" :label-width="formLabelWidth" class="rowItem" prop="area">
					<el-input v-model="form.area" placeholder="请输入场地面积"></el-input>
				</el-form-item>
				<el-form-item label="场地容纳人数:" :label-width="formLabelWidth" class="rowItem" prop="number">
					<el-input v-model="form.number" placeholder="请输入人数"></el-input>
				</el-form-item>
				<el-form-item label="收费标准:" :label-width="formLabelWidth" class="rowItem" prop="free">
					<el-input v-model="form.free" placeholder="请输入收费标准" type="textarea" :rows="8"></el-input>
				</el-form-item>
				<!-- <el-form-item label="备注:" :label-width="formLabelWidth" class="rowItem" prop="introduction">
					<el-input v-model="form.introduction" placeholder="请输入备注" type="textarea" :rows="8"></el-input>
        </el-form-item>-->
				<el-form-item label="备注:" :label-width="formLabelWidth" class="rowItem" prop="introduction">
					<el-input v-model="form.introduction" placeholder="请输入场地说明" type="textarea" :rows="8"></el-input>
					<el-radio-group v-model="form.isCan" size="mini">
						<el-radio :label="1" border>可预约</el-radio>
						<el-radio :label="2" border>不可预约</el-radio>
					</el-radio-group>
				</el-form-item>
				<div class="form-title">提供设备</div>
				<div style="height: 250px;">
					<el-form-item v-for="(item,index) in shebei" :key="index" :label="item.name" :label-width="formLabelWidth1" class="rowItem rowItem1"
					 prop="number">
						<el-input-number v-model="item.num" controls-position="right" @change="(value) => handleChange(value,index)" :min="0"></el-input-number>
					</el-form-item>
				</div>
				<div class="form-title">模式添加</div>
				<el-form-item label="会议模式:" :label-width="formLabelWidth" class="rowItem">
					<el-button type="primary" icon="el-icon-plus" @click="leixing">新增</el-button>
				</el-form-item>
				<div>
					<div class="allPics" v-for="(item,index) in photogList" :key="index">
						<i class="el-icon-circle-close" style="position:absolute;top: -6px;right:-7px;color:red;cursor:pointer;" @click="delImgList1(index)"></i>
						<el-form-item label="模式名称:">
							<el-input v-model="item.name" placeholder="请输入模式名称"></el-input>
						</el-form-item>
						<el-form-item label="图标选择:">
							<el-radio-group v-model="item.xiabiao" @change="(value) => select(value,index)">
								<el-radio :label="index" v-for="(item,index) in iconList" :key="index">
									<img :src="item" alt />
								</el-radio>
							</el-radio-group>
						</el-form-item>
						<div class="allPics1">
							<div class="flex-start-warp w100">
								<input type="file" name="file" multiple="multiple" @change="uploadPic(index)" class="imgInput w25" />
								<span class="w25 addPic-body pr" v-for="(data,i) in item.imgList" :key="i">
									<img :src="imgUrl +item.imgList[i]" class="addPic" />
									<i class="el-icon-circle-close addPic-close pointer" @click="delImgList(index,i)"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="createSite">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import CommonLayout from "../../components/common-layout.vue";
	import $axios from "axios";
	export default {
		components: {
			CommonLayout,
		},
		data() {
			return {
				is_submit: true,
				radio: "3",
				headerStyle: {
					color: "#623AA2",
					background: "#E5F3FE",
				},
				iconList: [
					require("../../assets/area2.png"),
					require("../../assets/icon16.png"),
					require("../../assets/icon18.png"),
					require("../../assets/icon20.png"),
				],
				photogList: [],
				number: 0,
				operationType: "add",
				current_page: 1,
				per_page: 10,
				searchValue: "",
				total: 20,
				dialogFormVisible: false,
				shebei: [{
						name: "投影仪",
						num: 0,
						icon: "../../assets/area/shebieicon01.png",
					},
					{
						name: "无线话筒",
						num: 0,
						icon: "../../assets/area/shebieicon02.png",
					},
					{
						name: "鹅颈话筒",
						num: 0,
						icon: "../../assets/area/shebieicon03.png",
					},
					{
						name: "65寸壁挂电视",
						num: 0,
						icon: "../../assets/area/shebieicon04.png",
					},
					{
						name: "80寸电视",
						num: 0,
						icon: "../../assets/area/shebieicon05.png",
					},
					{
						name: "LED显示大屏展示",
						num: 0,
						icon: "../../assets/area/shebieicon06.png",
					},
					{
						name: "音响系统",
						num: 0,
						icon: "../../assets/area/shebieicon06.png",
					},
				],
				form: {
					image: "",
					fieldName: "",
					isFree: 2, //1免费2收费
					isCan: 1, //1可预约 2不可预约
					introduction: "",
					area: "",
					number: "",
					free: "",
					device: "",
					model: "",
				},
				imgList: [],
				siteFormRule: {
					// 					image: [{
					// 						required: true,
					// 						message: '请上传场地图片',
					// 						trigger: 'blur'
					// 					}],
					fieldName: [{
						required: true,
						message: "请输入场地名称",
						trigger: "blur",
					}, ],
					introduction: [{
						required: true,
						message: "请输入场地说明",
						trigger: "blur",
					}, ],
				},
				formLabelWidth: "120px",
				formLabelWidth1: "140px",
				tableData: [],
			};
		},
		methods: {
			// 图标选择
			select(value, index) {
				this.photogList[index].xiabiao = value;
			},
			////////设备数量累加
			handleChange(value, i) {
				this.shebei[i].num = value;
			},
			leixing() {
				this.photogList.unshift({
					name: "",
					imgList: [],
					xiabiao: 0,
				});
			},
			delImgList1(index) {
				this.$confirm("确定删除此类照片吗?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
					})
					.then(() => {
						this.photogList.splice(index, 1);
						this.$message({
							type: "success",
							message: "删除成功!",
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			delImgList(index, i) {
				this.$confirm("确定删除图片吗?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
					})
					.then(() => {
						this.photogList[index].imgList.splice(i, 1);
						this.$message({
							type: "success",
							message: "删除成功!",
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			uploadPic(index, e) {
				let type = event.target.files[0],
					file = "",
					param = "",
					lis = event.target.files;
				for (let i = 0; i < lis.length; i++) {
					if (this.beforeAvatarUpload1(lis[i])) {
						file = lis[i];
						param = new FormData(); // 创建form对象
						param.append("file", file, file.name); // 通过append向form对象添加数据
						let config = {
							headers: {
								"Content-Type": "multipart/form-data",
							},
						}; // 添加请求头
						// console.log(event.target.files[0],'6')
						$axios.post(this.uploadURL, param, config).then((response) => {
							this.handlePictureListPreview(index, response.data, type);
						});
					}
				}
			},
			/////多张照片上传
			beforeAvatarUpload1(file) {
				let type = false;
				if (
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/jpg" ||
					file.type === "image/gif" ||
					file.type === "image/bmp"
				) {
					type = true;
				}
				var img = new Image();
				img.src = this.image;
				img.onload = function() {};
				const isLt2M = file.size / 1024 / 1024 < 10;
				if (!type) {
					this.$message.error("上传头像图片只能是 JPEG/jpg/png/gif/bmp 格式!");
				}
				if (!isLt2M) {
					this.$message.error("上传头像图片大小不能超过 10MB!");
				}
				return type && isLt2M;
			},
			handlePictureListPreview(index, res, file) {
				lrz(file, {
						width: 960,
					})
					.then((rst) => {
						this.http
							.post("/file/base64_upload", {
								image: rst.base64
							})
							.then((res) => {
								this.photogList[index].imgList.push(res.data);
								// this.form.image = res.data;
							});
						return rst;
					})
					.always(() => {
						// 清空文件上传控件的值
						file.target.value = null;
					});
				// this.photogList[index].imgList.push(res.data.store_result);
			},
			// 确认添加场地
			createSite() {
				if (this.photogList.length == 0) {
					this.$message.warning("请至少填写一个模式！");
					return;
				}
				for (var i = 0; i < this.photogList.length; i++) {
					if (
						this.photogList[i].name == "" ||
						this.photogList[i].imgList.length == 0
					) {
						this.$message.warning("请把模式填写完整！");
						return;
					}
				}
				this.form.device = JSON.stringify(this.shebei);
				this.form.model = JSON.stringify(this.photogList);
				if (!this.is_submit) {
					return;
				}
				this.is_submit = false;
				this.$refs["siteFormRule"].validate((valid) => {
					if (valid) {
						if (this.operationType == "add") {
							delete this.form.id;
							this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting-field/create`, this.form).then((res) => {
								if (res.code == 0) {
									this.ResetSearch(['searchValue'])

									this.$message.success("新建成功！");
									this.getData("Meeting_Field");
									this.dialogFormVisible = false;
								} else {
									this.is_submit = true;

									this.$message.error(res.status);
								}
							}).catch(err => {
								this.is_submit = true
							});
						} else {
							this.http
								.post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting-field/update`, this.form)
								.then((res) => {
									if (res.code == 0) {
										this.ResetSearch(['searchValue'])

										this.$message.success("编辑成功！");
										this.getData("Meeting_Field");
										this.dialogFormVisible = false;
									} else {
										this.is_submit = true;
										this.$message.error(res.status);
									}
								}).catch(err => {
									this.is_submit = true;
								});
						}
					} else {
						this.is_submit = true;

						console.log("error submit!!");
						return false;
					}
				});
			},
			openSiteModal(row) {
				this.operationType = row ? "edit" : "add";
				this.dialogFormVisible = true;
				this.resetForm();
				if (row) {
					this.form.image = row.image;
					this.form.fieldName = row.fieldName;
					this.form.isFree = row.isFree;
					this.form.isCan = row.isCan;
					this.form.introduction = row.introduction;
					this.form.area = row.area;
					this.form.number = row.number;
					this.form.id = row.id;
					this.form.free = row.free;
					console.log(row.model, row.device);
					if (row.model) {
						this.photogList = JSON.parse(row.model);
					} else {
						this.photogList = [];
					}
					if (row.device != "1") {
						this.shebei = JSON.parse(row.device);
					} else {
						this.shebei = [{
								name: "投影仪",
								num: 0,
								icon: "../../assets/area/shebieicon01.png",
							},
							{
								name: "无线话筒",
								num: 0,
								icon: "../../assets/area/shebieicon02.png",
							},
							{
								name: "鹅颈话筒",
								num: 0,
								icon: "../../assets/area/shebieicon03.png",
							},
							{
								name: "65寸壁挂电视",
								num: 0,
								icon: "../../assets/area/shebieicon04.png",
							},
							{
								name: "80寸电视",
								num: 0,
								icon: "../../assets/area/shebieicon05.png",
							},
							{
								name: "LED显示大屏展示",
								num: 0,
								icon: "../../assets/area/shebieicon06.png",
							},
							{
								name: "音响系统",
								num: 0,
								icon: "../../assets/area/shebieicon06.png",
							},
						];
					}
				}
			},
			shebieInit() {},
			resetForm() {
				this.form.image = "";
				this.form.fieldName = "";
				this.form.isFree = 2;
				this.form.isCan = 1;
				this.form.introduction = "";
				this.form.area = "";
				this.form.number = "";
				this.form.free = "";
				this.form.device = "";
				this.form.model = "";
				this.shebei = [{
						name: "投影仪",
						num: 0,
						icon: "../../assets/area/shebieicon01.png",
					},
					{
						name: "无线话筒",
						num: 0,
						icon: "../../assets/area/shebieicon02.png",
					},
					{
						name: "鹅颈话筒",
						num: 0,
						icon: "../../assets/area/shebieicon03.png",
					},
					{
						name: "65寸壁挂电视",
						num: 0,
						icon: "../../assets/area/shebieicon04.png",
					},
					{
						name: "80寸电视",
						num: 0,
						icon: "../../assets/area/shebieicon05.png",
					},
					{
						name: "LED显示大屏展示",
						num: 0,
						icon: "../../assets/area/shebieicon06.png",
					},
					{
						name: "音响系统",
						num: 0,
						icon: "../../assets/area/shebieicon06.png",
					},
				];
				this.photogList = [];
			},
			/* 封面上传成功 */
			handleAvatarSuccess(file) {
				this.form.image = file.data.store_result;
			},
			//上传图片
			HouImgFile(e) {
				var files = e.file;
				if (!files) return;
				this.createImage(files, e, "HouImg");
			},
			//其他图片上传
			createImage(file, e, Name) {
				//lrz压缩
				// lrz图片先压缩在加载、
				lrz(file, {
						width: 960,
					})
					.then((rst) => {
						this.http
							.post("/file/base64_upload", {
								image: rst.base64
							})
							.then((res) => {
								this.form.image = res.data;
							});
						return rst;
					})
					.always(() => {
						// 清空文件上传控件的值
						e.target.value = null;
					});
			},
			beforeAvatarUpload(file) {
				let type = false;
				if (
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/jpg" ||
					file.type === "image/gif" ||
					file.type === "image/bmp"
				) {
					type = true;
				}

				var img = new Image();
				img.src = this.image;
				img.onload = function() {};

				const isLt2M = file.size / 1024 / 1024 < 10;
				if (!type) {
					this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
				}
				if (!isLt2M) {
					this.$message.error("上传图片大小不能超过 10MB!");
				}
				return type && isLt2M;
			},
			//选择页码
			handleCurrentChange(e) {
				this.current_page = e;
				this.getData(`Meeting_Field?page=${this.current_page}&fieldName=${this.searchValue}`);
			},
			// 删除
			handleDelete(row) {
				this.$confirm("确定删除文件吗?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
					})
					.then(() => {
						this.http.request(`${urlConfig.devUrl}apij2/admin-api/trade/meeting-field/delete?id=` + row.id, "", "delete").then(
							(response) => {
								this.ResetSearch(['searchValue'])

								if (response.code == 0) {
									this.$message.success("删除成功！");
									this.getData("Meeting_Field");
								} else {
									this.$message.error(response.status);
								}
							},
							(error) => {}
						);
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			//搜索
			search() {
				this.getData(`Meeting_Field?fieldName=${this.searchValue}`);
			},
			getData(url) {
        let params = {};
        if(url.indexOf('?') > -1){
          let urlParams = url.split('?')[1]?.split('&')
          urlParams.forEach(item => {
            params[item.split('=')[0]] = item.split('=')[1]
          })
        }
        
				this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting-field/page`, params).then((res) => {
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.current_page = res.data.current_page;
						this.total = res.data.total;
						this.per_page = res.data.per_page;
					}
				});
			},
		},
		mounted() {
			this.getData("Meeting_Field");
		},
	};
</script>
<style lang="scss">
	@include component(site) {
		width: 100%;
		height: 100%;

		@include part(header) {
			display: flex;
			justify-content: flex-start;

			@include component(el-input) {
				width: 300px;
			}
		}

		@include part(searchBtn) {
			margin-left: 10px;
		}

		@include part(addBtn) {
			margin-right: 30px !important;
			background: #623aa2 !important;
			color: #fff;
			border: none;
		}

		@include part(table) {
			margin-top: 30px;
		}

		@include component(rowItem) {
			width: 50%;
		}

		@include component(el-radio-group) {
			width: 100%;
			text-align: left;
		}

		.avatar-uploader .el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		.avatar-uploader .el-upload:hover {
			border-color: #409eff;
		}

		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 178px;
			height: 130px;
			line-height: 130px;
			text-align: center;
		}

		.avatar {
			width: 178px;
			height: 178px;
			display: block;
		}

		.el-radio-group {
			display: flex;
		}

		.el-radio {
			display: flex;
			align-items: center;
		}

		.imgInput {
			background: url(../../assets/add.png) no-repeat;
			border: none;
			text-indent: -2000px;
			height: 120px;
			padding: 10px;
			background-size: 70%;
			background-position: center;
			color: white;
			cursor: pointer;
		}

		.imgInput:focus {
			border: none;
			outline: 0;
		}

		.allPics {
			border: 1px solid #ccc;
			padding: 18px 15px 10px 20px;
			width: 90%;
			margin: 0 auto;
			margin-bottom: 30px;
			position: relative;
			// display: flex;
			// flex-wrap: wrap;
			// justify-content: space-between;
		}

		.allPics1 {
			display: flex;
			// flex-wrap: wrap;
		}

		.addPic-body {
			padding: 10px;
			height: 120px;
		}

		.addPic-close {
			position: absolute;
			top: 10px;
			right: 10px;
		}

		.addPic {
			max-width: 100%;
			max-height: 100%;
		}

		.el-form-item__content {
			text-align: left;
		}

		.form-title {
			width: 100%;
			text-align: left;
			color: #623aa2;
			border-left: 5px solid #623aa2;
			border-bottom: 1px solid #623aa2;
			padding-left: 10px;
			font-size: 20px;
			margin-bottom: 20px;
			font-weight: 700;
		}

		.rowItem1 {
			float: left;
		}
	}
</style>
